module.exports = __webpack_public_path__ + "img/kj4.7e93dd5f.png";